// extracted by mini-css-extract-plugin
export default {"select":"CouponMasterSelect_select__mC0iT","coupon_enabled":"CouponMasterSelect_coupon_enabled__u-Vl5","selectable":"CouponMasterSelect_selectable__B2kuv"};